import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "api";
import { proceedThunk } from "./utils";

export const notesListThunk = createAsyncThunk(
  "note/list",
  proceedThunk(api.takebaker.notes.list)
);

export const createNoteThunk = createAsyncThunk(
  "note/create",
  proceedThunk(api.takebaker.notes.create)
);

export const updateNoteThunk = createAsyncThunk(
  "note/update",
  proceedThunk(api.takebaker.notes.update)
);

export const deleteNoteThunk = createAsyncThunk(
  "note/delete",
  proceedThunk(api.takebaker.notes.delete)
);
